// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue';
import App from './App';
import VueResource from 'vue-resource';
import util from '@/util.js';
//import unslider from '@/assets/web/js/unslidermin.js'
/*使用VueResource插件*/
Vue.use(VueResource);
Vue.use(util);
Vue.config.productionTip = false;
var domain = '', isTest = window.location.host.match('test');
if (isTest) {
  domain = 'test.';
}
Vue.prototype.apilist = {
  banner: 'http://' + domain + 'apicaidao.hexun.com/recommendposition/',//获取首页banner
  aggregation: 'http://' + domain + 'apilesson.hexun.com/investmethod/aggregation',//树
  hotlable: 'http://' + domain + 'apicaidao.hexun.com/recommendposition/17/1/10',//热门标签
  homestatistics: 'http://' + domain + 'apilesson.hexun.com/investment/homestatistics',//数据汇总
  gkklist: 'http://' + domain + 'apilesson.hexun.com/investment/classlist?pageNum=1&pageSize=6&chargeType=3&openStartDateNum=30&sortField=freeStartTime&sortOrder=DESC',//公开课列表
  //tjList:'http://' + domain + 'apilesson.hexun.com/investment/classlist?showprice&showbuystatus&classType=5&pageSize=4&pageNum=1&sortField=goodRate&firstType={codeType}&secondType',
  tjList: 'http://' + domain + 'apilesson.hexun.com/investment/classlist?showprice&showbuystatus&classType=5&pageSize=4&pageNum=1&sortField=monthLearnNum&firstType={codeType}&secondType',
  //从后台碎片请求原cms碎片数据
  incData: 'https://gw.homeway.com.cn/caidao/fragment/json/'
};
Vue.prototype.domain = domain;
/* eslint-disable no-new */
new Vue({
  el: '#app',
  template: '<App/>',
  components: { App }
});



// WEBPACK FOOTER //
// ./src/main.js